
import { firebaseMutations } from 'vuexfire/dist/vuexfire.esm'
import merge from 'lodash/merge'

export default {
  setMinimize(state, v) {
    state.minimize = v
  },
  setFocus(state, v) {
    state.focused = v
  },
  setTimeOnPage(state, v) {
    state.timeOnPage = v
  },
  setLastTimeUpdate(state, v) {
    state.lastTimeUpdate = v
  },
  setOrgId(state, v) {
    state.orgId = v
  },
  setWidgetId(state, v) {
    state.widgetId = v
  },
  setPrimaryBg(state, v) {
    state.widget.theme.primary_bg = v
  },
  setTempHide(state, v) {
    state.tempHide = v
  },
  setHidden(state, v) {
    state.hidden = v
  },
  setUID(state, v) {
    state.uid = v
  },
  pushFile(state, meta) {
    state.files.push(meta)
  },
  updateFile(state, { k, f, v }) {
    state.files[k][f] = v
  },
  setCache(state, v) {
    state.cache = v
  },
  syncState(state, v) {
    merge(state, v)
  },
  setConnectedState(state, v) {
    state.connected = v
  },
  setPreviewImg(state, v) {
    state.previewImg = v
  },
  doScroll(state) {
    state.doScroll = !state.doScroll
  },
  markReactionDone(state, v) {
    state.reactionsDone[v] = true
  },
  setTempLang(state, { label, value }) {
    if (state.widget && state.widget.language && state.widget.language[label])
      state.widget.language[label] = value
  },
  setTempHeader(state, { when, label, value }) {

    if (when && label && value)
      if (state.widget
        && state.widget.language
        && state.widget.options[when + '_form']
        && state.widget.options[when + '_form'].labels[label])
        state.widget.options[when + '_form'].labels[label] = value
  },
  setPageEventSid(state, sid) {
    state.pageEventSid = sid
  },
  setPageEventKey(state, pageEventKey) {
    state.pageEventKey = pageEventKey
  },
  setPageEventSubKey(state, pageEventSubKey) {
    state.pageEventSubKey = pageEventSubKey
  },
  setHistorySid(state, historySid) {
    state.historySid = historySid
  },
  setHistoryKey(state, historyKey) {
    state.historyKey = historyKey
  },
  setHistorySubKey(state, historySubKey) {
    state.historySubKey = historySubKey
  },
  ...firebaseMutations
}
